module.exports = __webpack_public_path__ + "d419d7ed4e34287bf7bb0c09c4c4f5ab.pdf";